import { FC } from 'react'
import icon from './paths'
import { IconProps } from './types'

const Icon: FC<IconProps> = ({ size, color, name, ...rest }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} {...rest}>
    <path d={icon[name]} fill={color} />
  </svg>
)

Icon.defaultProps = {
  size: 24,
  color: '#fff'
}

export default Icon
